import { useVesselVesselContractContext } from "./vesselVesselContractContext";

export function useVesselVesselContractStore() {
  return useVesselVesselContractContext();
}
